

import axios from 'axios';

// const mode = 'local';
// const mode = 'dev';
const mode = 'pro';
// const proxyurl = "https://cors-anywhere.herokuapp.com/";
const urlLocal = 'http://localhost:3033/';
const urlDev = 'https://ubo-apis.snailwalk.co/';
const urlPrd = 'https://bo-apis.snailwalk.co/';


let baseURL;
if (mode === 'local') {
  baseURL = `${urlLocal}`
} else if (mode === 'dev') {
  baseURL = `${urlDev}`
} else if (mode === 'pro') {
  baseURL = `${urlPrd}`
}

export default axios.create({
  baseURL: baseURL,
  responseType: 'json',
});

export const auth = {
    'Content-Type': 'application/json',
    'Authorization': '87cdf9229caf9a7fa3fd1403bcc5dd97'
}

export const apikey = '87cdf9229caf9a7fa3fd1403bcc5dd97'
